import { CaseChange, LoadAction, PegaFieldUpdates } from '@ap/pega';

export enum DistributionChannelType {
    RETAIL = 'Retail',
    MIJN = 'MijnOmgeving',
    MOBIEL = 'MobileApp'
}

export interface ApPegaEvents {
    /**
     * Called on case change, returns void by default. Override to implement.
     * @param caseChange CaseChange
     */
    onCaseChange(caseChange: CaseChange): void;

    /**
     * Called on caseType change, returns void by default. Override to implement.
     * @param caseTypeChange string
     */
    onCaseTypeChange(caseTypeChange: string): void;

    /**
     * Called on assignmentName change, returns void by default. Override to implement.
     * @param assignmentNameChange string
     */
    onAssignmentNameChanged(assignmentNameChange: string): void;

    /**
     * Called on LoadAction change, returns void by default. Override to implement.
     * @param loadAction LoadAction
     */
    onLoadAction(loadAction: LoadAction): void;

    /**
     * Called on assignment complete, returns void by default. Override to implement.
     * @param assignmentComplete string
     */
    onAssignmentComplete(pegaFieldUpdates: PegaFieldUpdates): void;
}
